import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { BUTTON, ERROR } from '../../Shared/Constants/LanguageKeys';
import FileUploadSectionViewer from './FileUploadSectionViewer';
import { ErrorLabel } from '../Forms';
import { ModalFileUpload } from '../Modal';
import { withTranslation } from 'react-i18next';


class FileUploadSectionAdder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalToggle: false,
            fileLimitError: ''
        };
    }

    // Toggle file upload modal
    toggleFileUploadModal = (callback) => {

        // If callback parameter is given, call it
        callback && callback();

        this.setState({ modalToggle: !this.state.modalToggle });
    };

    // Fn: Validate if file has reached given limit
    hasFileLimitReached = (fileList, uploadLimit) => {
        const { t } = this.props;
        // If no uploadLimit OR number didnt exceed uploadLimit
        if (uploadLimit === 0 || fileList.length < uploadLimit) {
            // Reset / Display no error text
            this.setState({ fileLimitError: '' });
            return false;
        }

        else {
            // Display error text
            this.setState({ fileLimitError: (t(ERROR.FILE_LIMIT_REACHED) + ERROR.LIMIT_LABEL) });
            return true;
        }
    };

    // Fn: Handle the actions of adder button
    handleAdderButton = ({ fileList, uploadLimit }) => {

        // If file upload limit has not reached
        if (!this.hasFileLimitReached(fileList, uploadLimit)) {

            // Toggle file upload modal
            this.toggleFileUploadModal();
        }
    };

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>

                {/* Button: For modal toggling */}
                <Col className={`remove-padding ${this.props.btnClassname}`}>
                    <Button color="neutral" onClick={() => this.handleAdderButton(this.props)}>
                        {`${t(BUTTON.ADD)} ${this.props.sectionName}`}
                    </Button>
                </Col>
                {/* Error Label: For file upload limit */}
                <ErrorLabel
                    message={this.state.fileLimitError}
                    formatter={{ limit: this.props.uploadLimit }}
                />

                {/* Incorporates the Viewer component inside*/}
                <FileUploadSectionViewer
                    name={this.props.name}
                    fileList={this.props.fileList}
                    getFileURL={this.props.getFileURL}
                    deleteFileURL={this.props.deleteFileURL}
                    onChangeField={this.props.onChangeField}
                    readonly={this.props.readonly}
                    hasFileLimitReached={() => this.hasFileLimitReached(this.props.fileList, this.props.uploadLimit)}
                    disableDescription={this.props.disableDescription}
                />

                {/* Modal: Renders FileUploadModal */}
                <ModalFileUpload
                    fileName={this.props.name}
                    fileList={this.props.fileList}
                    onConfirm={this.props.onChangeField}
                    isOpen={this.state.modalToggle}
                    toggleModal={this.toggleFileUploadModal}
                    contentHeader={`${t(BUTTON.ADD)} ${this.props.sectionName}`}
                    accept={this.props.accept}
                    disableDescription={this.props.disableDescription}
                />
            </React.Fragment>
        );
    }
}

// PropTypes: For prop validation
FileUploadSectionAdder.propTypes = {
    name: PropTypes.string.isRequired,
    fileList: PropTypes.array.isRequired,
    sectionName: PropTypes.string.isRequired,
    onChangeField: PropTypes.func.isRequired,
    uploadLimit: PropTypes.number,                       // 0 is unlimited
    accept: PropTypes.string,
};

// PropTypes: Defaulting value for optional props
FileUploadSectionAdder.defaultProps = {
    uploadLimit: 0
};


export default withTranslation()(FileUploadSectionAdder);